import { Injectable } from '@angular/core';
import { RestService } from '../../rest.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompetitorService {

  constructor(private restService: RestService) { }

  /**
   * Envía un reporte de disparidad tarifaria al backend.
   * Endpoint: POST /app/rate-competitions
   */
  createCompetitorReport(payload: any): Observable<any> {
    return this.restService.doPost('app', 'rate-competitions', payload);
  }
}
